import { Customer } from "./Customer";

export const LICENCE_VERSION_STANDARD = "v2";
export const LICENCE_VERSION_SAP = "v2-sap";

export type LicenceVersion =
  | typeof LICENCE_VERSION_STANDARD
  | typeof LICENCE_VERSION_SAP;

export const DEFAULT_LICENCE_VERSION: LicenceVersion = LICENCE_VERSION_STANDARD;

export const LICENCE_VERSION_LABELS: Record<LicenceVersion, string> = {
  [LICENCE_VERSION_STANDARD]: "Standard",
  [LICENCE_VERSION_SAP]: "SAP",
};

export const LICENCE_VERSIONS: LicenceVersion[] = [
  LICENCE_VERSION_STANDARD,
  LICENCE_VERSION_SAP,
];

export const normalizeLicenceVersion = (value: unknown): LicenceVersion =>
  value === LICENCE_VERSION_SAP
    ? LICENCE_VERSION_SAP
    : LICENCE_VERSION_STANDARD;

export const isSapLicenceVersion = (value: unknown): boolean =>
  normalizeLicenceVersion(value) === LICENCE_VERSION_SAP;

export type GeneratorLicenceInput = {
  installation_id: string;
  migrations: number;
  replicas: number;
  start_date?: string | null;
  end_date: string | null;
  duration?: number | null;
  type: "floating" | "fixed";
  version?: LicenceVersion | null;
};

export type LicenceInput = GeneratorLicenceInput & {
  name?: string;
  description: string | null;
  customer_id?: string;
  new_customer?: { name: string; email?: string | null };
  tag: string | null;
  support?: string | null;
};

export type Licence = LicenceInput & {
  id: string;
  created_at: string;
  created_by: string;
};

class LicenceHelper {
  static getName(licence: Licence | null, customer: Customer | null): string {
    return licence?.name || customer?.name || "";
  }
}

export default LicenceHelper;
